export function createTourQueue({ order = [], isBusy = () => false } = {}) {
  let shownThisVisit = false
  let pending = []

  const position = tour => {
    const index = order.indexOf(tour)
    return index === -1 ? order.length : index
  }

  const grant = () => {
    const [first] = [...pending].sort((a, b) => position(a.tour) - position(b.tour))
    pending = []
    if (!first || shownThisVisit || isBusy()) return
    shownThisVisit = true
    first.start()
  }

  return {
    request(tour, start) {
      if (shownThisVisit) return
      if (!pending.length) queueMicrotask(grant)
      pending.push({ tour, start })
    },
    release() {
      shownThisVisit = false
    }
  }
}
